<script setup>
import { useI18n } from 'vue-i18n';

import Editor from 'dashboard/components-next/Editor/Editor.vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';

defineProps({
  isEmailOrWebWidgetInbox: { type: Boolean, required: true },
  hasErrors: { type: Boolean, default: false },
  hasAttachments: { type: Boolean, default: false },
  sendWithSignature: { type: Boolean, default: false },
  messageSignature: { type: String, default: '' },
  channelType: { type: String, default: '' },
});

const { t } = useI18n();

const modelValue = defineModel({
  type: String,
  default: '',
});

</script>

<template>
  <div class="flex-1 h-full" :class="[!hasAttachments && 'min-h-[200px]']">
    <template v-if="isEmailOrWebWidgetInbox">
      <Editor
        v-model="modelValue"
        :placeholder="
          t('COMPOSE_NEW_CONVERSATION.FORM.MESSAGE_EDITOR.PLACEHOLDER')
        "
        class="[&>div]:!border-transparent [&>div]:px-4 [&>div]:py-4 [&>div]:!bg-transparent h-full [&_.ProseMirror-woot-style]:!max-h-[200px]"
        :class="
          hasErrors
            ? '[&_.empty-node]:before:!text-n-ruby-9 [&_.empty-node]:dark:before:!text-n-ruby-9'
            : ''
        "
        enable-variables
        :show-character-count="false"
      />
    </template>
    <template v-else>
      <WootMessageEditor
        v-model="modelValue"
        :placeholder="
          t('COMPOSE_NEW_CONVERSATION.FORM.MESSAGE_EDITOR.PLACEHOLDER')
        "
        class="!px-0 [&_.ProseMirror-menubar]:!hidden [&_.ProseMirror]:!px-4 [&_.ProseMirror]:!bg-transparent"
        allow-signature
        :signature="messageSignature"
        :channel-type="channelType"
      />
    </template>
  </div>
</template>
